<template>
  <div>
    <ViewEvolution
      :key="evolution.id"
      :title="evolution.name"
      :type="evolution.type"
      :target="evolution.target"
      :resident_id="resident_id"
    />
  </div>
</template>

<script>
import ViewEvolution from "../Evolution/View.vue";

import api from "../../services/api";

export default {
  name: "MenuStandarEvolution",

  components: {
    ViewEvolution,
  },

  props: {
    evolution_type: { type: [String] },
    resident_id: { type: [Number] },
  },

  data() {
    return {
      evolution: {},

      loading: false,
    };
  },

  watch: {
    evolution_type: {
      immediate: true,
      handler(evolution_type) {
        if (evolution_type) {
          this.getEvolutionType(evolution_type);
        }
      },
    },
  },

  methods: {
    async getEvolutionType(evolution_type) {
      try {
        this.loading = true;

        let params = { evolution_type };

        const response = await api.get(
          "/rest-home/evolutions/settings/by-type",
          { params }
        );

        const { evolution } = response.data;

        this.evolution = evolution;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>
